import { NewsPanel } from './panels/NewsPanel';
import { ClubCalendarPanel } from './panels/ClubCalendarPanel';
import { ClubLayout } from './layouts/ClubLayout';
import { ClubGrid } from './club/ClubGrid';
import { TeamSection } from './club/TeamSection';
import { WishlistPanel } from './panels/WishlistPanel';
import { SidebarLayout } from './layouts/SidebarLayout';
import { usePerformanceMonitoring } from '../hooks/usePerformanceMonitoring';
import { useNavigationTracking } from '../hooks/useNavigationTracking';

export const MyClub = () => {
  // Use our custom hooks for performance monitoring and navigation tracking
  usePerformanceMonitoring('MyClub');
  useNavigationTracking('my-club');
  
  // Main content grid
  const mainContent = (
    <ClubGrid
      teamPanel={<TeamSection />}
    />
  );
  
  // Left sidebar content (news and fixtures)
  const leftSidebarContent = (
    <div className="space-y-6">
      <NewsPanel vertical={true} />
      <ClubCalendarPanel />
    </div>
  );
  
  // Right sidebar content (wishlist)
  const rightSidebarContent = <WishlistPanel />;
  
  return (
    <ClubLayout>
      <SidebarLayout
        leftSidebar={leftSidebarContent}
        main={mainContent}
        sidebar={rightSidebarContent}
      />
    </ClubLayout>
  );
};